export function getAuth() {
  return localStorage.getItem("auth");
}

export function getTokens() {
  const auth = getAuth();
  if (auth) {
    return JSON.parse(auth).tokens;
  }
  return null;
}

export function getAccessToken() {
  const tokens = getTokens();
  if (tokens) {
    return tokens.access.token;
  }
  return null;
}














